// Servicio de la exportación a Excel del monitoreo de asistencia.
// GET /attendance/monitoring/file — responde 200 con el archivo o 202 con el jobId.

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';
import type {
  LC_ExportMonitoringIn,
  MonitoringExportHybridResult,
} from '../types/monitoringExport.types';


export class MonitoringExportService {
  async export(
    filters: LC_ExportMonitoringIn,
  ): Promise<ApiResponse<MonitoringExportHybridResult>> {
    const query = buildQueryString({ ...filters });
    const endpoint = `${API_CONFIG.ENDPOINTS.MONITORING_EXPORT}${query}`;

    return apiClient.downloadBlobOrAcceptJob(endpoint, { method: 'GET' });
  }
}

export const monitoringExportService = new MonitoringExportService();
